const mapperLanguageToForm = languages => {
    const { id, language, proficiency, other_languages } = languages

    return {
        id,
        language: {
            label: language,
            value: language,
        },
        proficiency: {
            label: proficiency,
            value: proficiency,
        },
        other_languages,
    }
}

export { mapperLanguageToForm }
